import { render, staticRenderFns } from "./brainPowerTitle.vue?vue&type=template&id=fa671198&scoped=true&"
import script from "./brainPowerTitle.ts?vue&type=script&lang=js&"
export * from "./brainPowerTitle.ts?vue&type=script&lang=js&"
import style0 from "./brainPowerTitle.less?vue&type=style&index=0&id=fa671198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa671198",
  null
  
)

export default component.exports